import React, { useMemo } from "react";
import Table from "../../../../components/Table";
import { Column } from "../../../../components/Table/types";
import columns, {
  columnDiscount, columnMinPrice,
  columnPrice,
  columnPriceBeforeDiscount
} from "./columns";
import itemToRow from "./columns/itemToRow";
import { Columns } from "./columns/types";
import { TableProductsFC } from "./types";
import useTable from "./useTable";

const TableProducts: TableProductsFC = ({ logId, marketplace }) => {
  const { isLoading, products } = useTable(logId);
  const actualColumns: Column<Columns>[] = useMemo(() => {
    const result = [...columns];
    if (products.some(({ price }) => Number.isFinite(price))) {
      result.splice(-1, 0, columnPrice);
    }
    if (products.some(({ discount }) => Number.isFinite(discount))) {
      result.splice(-1, 0, columnDiscount);
    }
    if (
      products.some(({ priceBeforeDiscount }) =>
        Number.isFinite(priceBeforeDiscount)
      )
    ) {
      result.splice(-1, 0, columnPriceBeforeDiscount);
    }
    if (products.some(({ minPrice }) => Number.isFinite(minPrice))) {
      result.splice(-1, 0, columnMinPrice);
    }
    return result;
  }, [products]);

  return (
    <Table
      columns={actualColumns}
      disablePagination
      loading={isLoading}
      rows={products.map(itemToRow)}
    />
  );
};

export default TableProducts;
